import React from "react";
import { Form } from "react-bootstrap";
import { allowOnlyNumbers } from "../../../system";

const SubscriptionFields = (props) => {
  const {
    startLabel,
    endLabel,
    isHorizontalLine = false,
    currencyLabel,
    disabled,
    placeholder,
    id,
    register,
  } = props;
  return (
    <>
      <Form.Group className="d-flex justify-content-between align-items-center px-3">
        <Form.Label className="subscription-field-label">
          {startLabel}
        </Form.Label>
        <div className="d-flex align-items-center">
          {currencyLabel && (
            <p className="subscription-field-currency">{currencyLabel}</p>
          )}
          <Form.Control
            className="subscription-field"
            type="number"
            id={id}
            disabled={disabled}
            placeholder={placeholder}
            {...register}
            onKeyDown={(e)=>allowOnlyNumbers(e)}
          />
          <p className="ms-2">{endLabel}</p>
        </div>
      </Form.Group>
      {isHorizontalLine && <p className="subscription-horizental-line " />}
    </>
  );
};

export default SubscriptionFields;
